import { convertSvgPathToEditableGeometry, ShapePoint } from "./curvedLotShape";

// Match the stage editor's vertex average, excluding curve control points and
// the repeated closing vertex in serialized SVG paths.
export const getBoundaryLabelCenter = (
  boundaryPath?: string,
  boundaryPoints?: ShapePoint[]
): ShapePoint | null => {
  const points =
    boundaryPoints && boundaryPoints.length >= 3
      ? boundaryPoints
      : convertSvgPathToEditableGeometry(boundaryPath ?? "", 0.0001)?.points;

  if (!points?.length) return null;

  return {
    x: points.reduce((sum, point) => sum + point.x, 0) / points.length,
    y: points.reduce((sum, point) => sum + point.y, 0) / points.length,
  };
};
